import { SiteConfig } from "@/contents/sanityTypes"
import { SiteMetadata } from "@/modules/seo/SiteMetadata"
import {
  contentSquareId,
  cookiebotDisabled,
  googleAnalyticsId,
  googleTagManagerId,
} from "@/settings"
import RawScript from "@/ui/structure/RawScript"
import Script from "next/script"

export interface PageHeadProps {
  settings: SiteConfig
  disableCookiebot?: boolean
}

const PageHead = ({
  settings,
  disableCookiebot = cookiebotDisabled,
}: PageHeadProps) => {
  return (
    <>
      {settings.scripts?.map((script: any) => (
        <RawScript key={script._uid} value={script.content ?? ""} />
      ))}

      {!disableCookiebot && (
        <Script
          id="Cookiebot"
          src="https://consent.cookiebot.com/uc.js"
          data-cbid="2e791c0a-b526-42ec-8ba7-60d67b0c0cb9"
          data-blockingmode="auto"
          strategy="beforeInteractive"
        />
      )}

      <Script
        id="google-gtag"
        src="https://www.googletagmanager.com/gtag/js?id=G-5V6NCSTJN8"
        strategy="afterInteractive"
      />

      {googleTagManagerId && (
        <Script id="google-tag-manager">
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${googleTagManagerId}');`}
        </Script>
      )}

      {googleAnalyticsId && (
        <Script id="google-analytics" strategy="afterInteractive">
          {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', '${googleAnalyticsId}');
        `}
        </Script>
      )}

      {contentSquareId && (
        <Script id="contentsquare" strategy="afterInteractive">
          {`
          (function (c, s, q, u, a, r, e) {
              c.hj=c.hj||function(){(c.hj.q=c.hj.q||[]).push(arguments)};
              c._hjSettings = { hjid: a };
              r = s.getElementsByTagName('head')[0];
              e = s.createElement('script');
              e.async = true;
              e.src = q + c._hjSettings.hjid + u;
              r.appendChild(e);
          })(window, document, 'https://static.hj.contentsquare.net/c/csq-', '.js', ${contentSquareId});
          `}
        </Script>
      )}

      <SiteMetadata />
    </>
  )
}

export default PageHead
